import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiTag, FiDatabase, FiUsers, FiUser } = FiIcons;

const MetadataPanel = ({ 
  metaTitle, 
  metaDescription, 
  onMetaTitleChange, 
  onMetaDescriptionChange,
  owner,
  associatedUser
}) => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
        <SafeIcon icon={FiSearch} className="text-lg" />
        <span>SEO Metadata</span>
        <SafeIcon icon={FiDatabase} className="text-sm text-blue-600" />
      </h3>

      {/* Client/Owner and User Display */}
      <div className="space-y-3">
        {owner && (
          <div className="bg-purple-50 rounded-lg p-3 border border-purple-200">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiUsers} className="text-sm text-purple-600" />
              <span className="text-sm font-medium text-purple-800">Client/Owner:</span>
            </div>
            <p className="text-purple-900 font-semibold mt-1">{owner}</p>
          </div>
        )}

        {associatedUser && (
          <div className="bg-green-50 rounded-lg p-3 border border-green-200">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiUser} className="text-sm text-green-600" />
              <span className="text-sm font-medium text-green-800">Associated User:</span>
            </div>
            <p className="text-green-900 font-semibold mt-1">{associatedUser}</p>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Title Tag
            <span className="text-xs text-gray-500 ml-1">(Supabase: title_tag)</span>
          </label>
          <input
            type="text"
            value={metaTitle}
            onChange={(e) => onMetaTitleChange(e.target.value)}
            placeholder="Enter SEO title tag (50-60 characters)"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            maxLength={60}
          />
          <div className="text-xs text-gray-500 mt-1">
            {metaTitle.length}/60 characters
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Meta Description
            <span className="text-xs text-gray-500 ml-1">(Supabase: meta_description)</span>
          </label>
          <textarea
            value={metaDescription}
            onChange={(e) => onMetaDescriptionChange(e.target.value)}
            placeholder="Enter SEO meta description (150-160 characters)"
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
            maxLength={160}
          />
          <div className="text-xs text-gray-500 mt-1">
            {metaDescription.length}/160 characters
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200 pt-4">
        <h4 className="text-sm font-medium text-gray-700 mb-3 flex items-center space-x-2">
          <SafeIcon icon={FiTag} className="text-sm" />
          <span>Supabase Sync</span>
        </h4>
        <ul className="text-xs text-gray-600 space-y-1">
          <li>• Changes saved to automatic_article_addition table</li>
          <li>• Real-time sync with database</li>
          <li>• Articles grouped by client/owner AND user</li>
          <li>• Dual organization: by client and by user</li>
          <li>• Preserves semantic HTML structure</li>
          <li>• Maintains SEO placeholders like [Image suggestion]</li>
          <li>• Word count validates 1000-1500 target</li>
        </ul>
      </div>
    </div>
  );
};

export default MetadataPanel;